import React, { useContext, useEffect, useState } from 'react';
import { InventoryCheck } from '../../InventoryCheckView';
import InventoryCheckTabInventory from './InventoryCheckTabInventory';
import InventoryCheckTabLostBowls from './InventoryCheckTabLostBowls';
import { Communicator } from '../../../tools/Communication';
import i18n from '@/utils/i18n';
import {
  CanAccessPartnerData,
  ViewerContext,
} from '../../../providers/ViewerContextProvider';
import { type DateRange } from 'react-day-picker';

export const getInventoryCheckStatusColor = (i: InventoryCheck): string => {
  console.log(
    `getInventoryCheckStatusColor - isExpired: ${i.isExpired}, isBillable:${i.isBillable}, status:${i.status}`,
  );

  if (i.status === 3) {
    return 'secondary';
  }

  if (i.status === 2) {
    return 'secondary';
  }

  if (i.isExpired) {
    return 'secondary';
  }

  return 'success';
};

export const getInventoryStatusString = (i: InventoryCheck) => {
  console.log(
    `getInventoryStatusString - isExpired: ${i.isExpired}, isBillable:${i.isBillable}, status:${i.status}`,
  );

  if (i.isExpired) {
    return i18n.t('InventoryCheck:Status:2');
  }

  return i18n.t(`InventoryCheck:Status:${i.status}`);
};

interface ContainerType {
  id: number;
  name: string;
}

type InventoryCheckTabPageProps = {
  vytalStoreGuid: string;
  title: string;
};

const InventoryCheckTab = ({
  vytalStoreGuid,
  title,
}: InventoryCheckTabPageProps) => {
  const viewer = useContext(ViewerContext);
  const showPartnerData = CanAccessPartnerData(viewer);

  const [storeId, setStoreId] = useState(vytalStoreGuid);
  const [isLoading, setIsLoading] = useState(true);
  const [inventoryChecks, setInventoryChecks] = useState<InventoryCheck[]>([]);
  const [containerTypes, setContainerTypes] = useState<ContainerType[]>([]);
  const [dateRange, setDateRange] = useState<DateRange | undefined>({
    from: new Date(new Date().setMonth(new Date().getMonth() - 3)),
    to: new Date(),
  });

  const reloadContainerTypes = () => {
    Communicator.Get('/Container/GetAllContainerCategories', {})
      .then((response) => response.json())
      .then((data: { containerTypes: ContainerType[] }) => {
        if (data.containerTypes) {
          // assume that container types have ids from 1 to n without 'holes'
          setContainerTypes(
            [...data.containerTypes].sort((a, b) => a.id - b.id),
          );
        }
      });
  };

  const updateData = async (isLoadingArg = true) => {
    if (isLoadingArg) {
      setIsLoading(true);
    }

    const params: Record<string, string> = { storeId };
    if (dateRange?.from) {
      params.from = dateRange.from.toISOString();
    }
    if (dateRange?.to) {
      params.to = dateRange.to.toISOString();
    }

    return Communicator.Get('api/3/InventoryCheck/GetAll', params)
      .then((response) => response.json())
      .then((inventoryChecks: InventoryCheck[]) => {
        if (inventoryChecks) {
          setInventoryChecks(inventoryChecks);
        }

        if (isLoadingArg) {
          setIsLoading(false);
        }
      });
  };

  useEffect(() => {
    const promises = [updateData(false), reloadContainerTypes()];

    Promise.all(promises).then(() => {
      setIsLoading(false);
    });
  }, []);

  useEffect(() => {
    (async () => {
      if (vytalStoreGuid) {
        await updateData();

        setStoreId(vytalStoreGuid);
      }
    })();
  }, [vytalStoreGuid]);

  useEffect(() => {
    if (storeId && dateRange?.from && dateRange?.to) {
      updateData();
    }
  }, [dateRange]);

  return (
    <>
      <InventoryCheckTabInventory
        vytalStoreGuid={vytalStoreGuid}
        title={title}
        isLoading={isLoading}
        containerTypes={containerTypes}
        inventoryChecks={inventoryChecks}
        dateRange={dateRange}
        onDateRangeChange={setDateRange}
      />

      {showPartnerData && (
        <InventoryCheckTabLostBowls
          vytalStoreGuid={vytalStoreGuid}
          isLoading={isLoading}
          containerTypes={containerTypes}
          inventoryChecks={inventoryChecks}
        />
      )}
    </>
  );
};

export default InventoryCheckTab;
